import React, { useCallback, useLayoutEffect } from 'react';
import Animated from 'react-native-reanimated';
import { AppView, CardView, SettingsItemNavigate } from 'design-system';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import IconPercent from 'design-system/icons/IconPercent';
import SectionHeader from 'design-system/SectionHeader';
import { SCROLL_INDICATOR_INSETS } from 'design-system/values';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import { HELP_ARTICLES_KEY } from 'features/help/constants';
const PotsSettings = withAnimatedNavigationHeader(({ scrollHandler, navigation }) => {
    const { paddingHorizontalStyle } = useAppFrameDimensions();
    const contentContainerStyle = useMarginBottom('paddingBottom', undefined, paddingHorizontalStyle);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerRight: () => <HelpScreenButton articlesKey={HELP_ARTICLES_KEY.POTS_SETTINGS}/>,
        });
    }, []);
    const handlePotsStatement = useCallback(() => {
        navigation.navigateDeprecated('ExportStatement', { type: 'Pots' });
    }, []);
    return (<AppView type="secondary" withFrame={false}>
        <Animated.ScrollView scrollEventThrottle={16} onScroll={scrollHandler} contentContainerStyle={contentContainerStyle} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}>
          <SectionHeader horizontalMargins largeVerticalMargins>
            Statements
          </SectionHeader>
          <CardView noMarginTop>
            <SettingsItemNavigate onPress={handlePotsStatement} title="Interest pots statement" icon={<IconPercent gradientKey="apricot"/>}/>
          </CardView>
        </Animated.ScrollView>
      </AppView>);
}, ({ colors }) => ({
    title: 'Settings',
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
export default PotsSettings;
